import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Footer() {
  const { lang } = useLanguage();
  return (
    <footer style={{
      background: 'rgba(0,0,0,0.3)',
      borderTop: '1px solid rgba(201,168,76,0.15)',
      padding: '2rem',
      textAlign: 'center',
      position: 'relative',
      zIndex: 1,
    }}>
      <p style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic', fontSize: '1rem', color: 'var(--gold)', marginBottom: '0.5rem' }}>
        ✦ {lang === 'de' ? 'Ich war nie allein!' : "Je n'ai jamais été seul !"} ✦
      </p>
      <p style={{ fontSize: '0.75rem', color: 'rgba(245,233,198,0.4)', letterSpacing: '0.1em' }}>
        Michel · 50. Geburtstag · 11. Juli 2026 · Erlangen
      </p>
    </footer>
  );
}
